module.exports = __webpack_public_path__ + "media/images/forms/form-validation-invalid-195e401568bb4a6acf731fe5456939fc.svg";